var deprecationData = {
  Avatar: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  Breadcrumbs: [{
    name: 'crumbs',
    replacement: 'the <Breadcrumbs.Item> sub component'
  }],
  Button: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }, {
    name: 'outlined',
    replacement: 'type="secondary"'
  }, {
    name: 'alert',
    replacement: 'type="destructive"'
  }, {
    name: 'raised',
    replacement: 'type="primary"'
  }, {
    name: 'icon',
    replacement: 'iconOnly'
  }],
  Caption: [{
    name: 'highlight',
    replacement: 'the .hc-bg-highlight helper class'
  }],
  Card: [{
    name: 'plane',
    replacement: 'elevation'
  }],
  Chip: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }, {
    name: 'uppercase',
    replacement: false
  }, {
    name: 'inverted',
    replacement: 'type="subtle"'
  }, {
    name: 'state',
    replacement: false
  }],
  DateFormatter: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  Dialog: [{
    name: 'onApproveDialog',
    replacement: 'onApprove'
  }, {
    name: 'onRefuseDialog',
    replacement: 'onRefuse'
  }],
  Dropdown: [{
    name: 'width',
    replacement: 'size="dense|normal|expanded"'
  }],
  DropdownMenu: [{
    name: 'width',
    replacement: 'size="dense|normal|expanded"'
  }],
  FormField: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  Heading: [{
    name: 'as',
    replacement: 'the default tags the Heading component renders so that semantic HTML for screen readers is maintained. If you need your Heading to be clickable, please wrap it in an Anchor component'
  }],
  Image: [{
    name: 'size',
    replacement: 'type'
  }],
  InputChip: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }, {
    name: 'defaultValue',
    replacement: 'defaultChecked'
  }],
  InputChips: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }, {
    name: 'As',
    replacement: false
  }],
  InputColor: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }],
  InputDate: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }],
  InputDatetimeLocal: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }],
  InputEmail: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }],
  InputIconToggle: [{
    name: 'as',
    replacement: false
  }, {
    name: 'checkedIcon',
    replacement: 'type="bookmark, flag, heart, lock, pin, star, or visible"'
  }, {
    name: 'uncheckedIcon',
    replacement: 'type="bookmark, flag, heart, lock, pin, star, or visible"'
  }, {
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  InputMonth: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }],
  InputNumber: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }],
  InputPassword: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }],
  InputRadio: [{
    name: 'as',
    replacement: false
  }, {
    name: 'success',
    replacement: false
  }, {
    name: 'alert',
    replacement: false
  }],
  InputSelect: [{
    name: 'multiple',
    replacement: 'use the Autocomplete component for selection of multiple values'
  }, {
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }],
  InputText: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  InputTextarea: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  InputTime: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  InputToggle: [{
    name: 'highlight',
    replacement: 'the .hc-bg-highlight helper class'
  }, {
    name: 'alert',
    replacement: false
  }, {
    name: 'success',
    replacement: false
  }],
  InputUrl: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  InputWeek: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  LayoutNotification: [{
    name: 'error',
    replacement: 'type="error"'
  }, {
    name: 'success',
    replacement: 'type="success"'
  }],
  List: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  Modal: [{
    name: 'closeButton',
    replacement: false
  }, {
    name: 'onRefuseModal',
    replacement: 'onRefuse'
  }],
  Pagination: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }, {
    name: 'outlined',
    replacement: false
  }, {
    name: 'iconsOnly',
    replacement: false
  }, {
    name: 'next',
    replacement: 'onRequestNext'
  }, {
    name: 'prev',
    replacement: 'onRequestPrev'
  }],
  PlaceholderCircle: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  Popover: [{
    name: 'padding',
    replacement: false
  }, {
    name: 'width',
    replacement: 'size="normal", size="expanded", or size="dense"'
  }, {
    name: 'openOn',
    replacement: 'type'
  }],
  ProgressBar: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }, {
    name: 'inverted',
    replacement: false
  }, {
    name: 'rounded',
    replacement: false
  }, {
    name: 'success',
    replacement: 'percentComplete="100" to turn the bar green on completion'
  }],
  Rating: [{
    name: 'average',
    replacement: 'averageValue'
  }, {
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  SideNav: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }, {
    name: 'position',
    replacement: false
  }],
  Spinner: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }, {
    name: 'inline',
    replacement: 'size="inline"'
  }],
  Spotlight: [{
    name: 'light',
    replacement: false
  }, {
    name: 'dark',
    replacement: false
  }, {
    name: 'contentWidth',
    replacement: 'size'
  }],
  Stepper: [{
    name: 'justified',
    replacement: false
  }],
  'Stepper.Step': [{
    name: 'alert',
    replacement: 'error'
  }],
  Tabs: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }],
  TargetLogo: [{
    name: 'dense',
    replacement: 'size="dense"'
  }, {
    name: 'expanded',
    replacement: 'size="expanded"'
  }, {
    name: 'inline',
    replacement: 'size="inline"'
  }],
  Thumbnail: [{
    name: 'success',
    replacement: 'type="success"'
  }, {
    name: 'error',
    replacement: 'type="error"'
  }, {
    name: 'loading',
    replacement: 'type="loading"'
  }],
  Timeline: [{
    name: 'dense',
    replacement: false
  }, {
    name: 'expanded',
    replacement: false
  }],
  TimelineFlag: [{
    name: 'success',
    replacement: 'type="success"'
  }, {
    name: 'error',
    replacement: 'type="error"'
  }],
  TimelineItem: [{
    name: 'inverted',
    replacement: false
  }, {
    name: 'active',
    replacement: false
  }, {
    name: 'success',
    replacement: 'type="success"'
  }, {
    name: 'error',
    replacement: 'type="error"'
  }],
  Toaster: [{
    name: 'color',
    replacement: 'type="success", type="error", or type="default" will auto-generate the correct color'
  }, {
    name: 'onActionHide',
    replacement: 'the toast will wait for the user action if onApprove or onRefuse is present'
  }, {
    name: 'onApproveToast',
    replacement: 'onApprove'
  }, {
    name: 'onRefuseToast',
    replacement: 'onRefuse'
  }, {
    name: 'onToastComplete',
    replacement: 'onComplete'
  }, {
    name: 'headingText',
    replacement: 'heading'
  }, {
    name: 'approveButtonText',
    replacement: 'links array that accepts text and onClick function'
  }, {
    name: 'refuseButtonText',
    replacement: 'links array that accepts text and onClick function'
  }],
  Tooltip: [{
    name: 'wrap',
    replacement: 'the Tooltip will wrap automatically when it reaches a specific width'
  }]
};
var alertUserOfDeprecatedProps = function alertUserOfDeprecatedProps(componentName, otherProps, color) {
  // run through the otherProps passed to this component to see if any are deprecated
  deprecationData["".concat(componentName)] && deprecationData["".concat(componentName)].map(function (prop) {
    var replacementInfo = prop.replacement ? "Please use ".concat(prop.replacement, ".") : "There is no replacement for this functionality. If this is an issue, please contact the Enterprise UI team on Slack at #canvas-ui.";

    // check each prop for deprecation
    if (otherProps[prop.name]) {
      var deprecationInfo = "The ".concat(componentName, " component no longer supports the property ").concat(prop.name, ".");
      console.error("Hey Canvas User! ".concat(deprecationInfo, " ").concat(replacementInfo));
    }
  });

  // if this component has a color prop, check to see that the value is not deprecated
  if (color) {
    var deprecatedColorList = [];
    var errorMessage = '';
    if (componentName === 'Chip') {
      deprecatedColorList = ['yellow', 'green', 'orange', 'lightGrey', 'darkGrey', 'indigo', 'lime', 'mint', 'pink', 'teal', 'red', 'violet'];
      errorMessage = "Hey Canvas User! The Chip component no longer supports the color \"".concat(color, "\" because UX has recomended limiting Chip color options. There is no replacement for this functionality. If this is an issue, please contact the Enterprise UI team on Slack at #canvas-ui.");
    } else {
      deprecatedColorList = ['yellow', 'green', 'orange', 'lightGrey', 'darkGrey'];
      errorMessage = "Hey Canvas User! The ".concat(componentName, " component no longer supports the color \"").concat(color, "\" because it is now reserved for indicating a status. There is no replacement for this functionality. If this is an issue, please contact the Enterprise UI team on Slack at #canvas-ui.");
    }
    if (deprecatedColorList.includes(color)) {
      console.error(errorMessage);
    }
  }
};

export { alertUserOfDeprecatedProps as default };
